import { render, staticRenderFns } from "./informationAdd.vue?vue&type=template&id=6c288cb4&scoped=true&"
import script from "./informationAdd.vue?vue&type=script&lang=js&"
export * from "./informationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c288cb4",
  null
  
)

export default component.exports